import { ApolloError } from '@apollo/client';
import { processCensus, submitCensus } from 'api/operations/censusService';
import { action, makeObservable, runInAction } from 'mobx';
import ICensusReviewPageStore, { CensusReviewDomainParams } from '../iCensusReviewPageStore';

export default abstract class IEnrollmentCensusReviewPageStore extends ICensusReviewPageStore<CensusReviewDomainParams> {
  public async getStatistics(): Promise<void> {
    this.setIsLoading(true);
    try {
      const { statistics, families, headers } = await processCensus(
        this._domainData.groupId,
        this._domainData.enrollmentPeriodId,
      );
      runInAction(() => {
        this._statistics = statistics;
        this._families = families;
        this._headers = headers;
      });
    } catch (error) {
      runInAction(() => {
        this._setIncompatibilityErrorMsg((error as ApolloError).message);
      });
    }
    this.setIsLoading(false);
  }

  public async onCensusSubmit(): Promise<void> {
    this.setIsLoading(true);
    await submitCensus(this._domainData.groupId, this._domainData.enrollmentPeriodId);

    this.setIsLoading(false);
    this.onCompleteRedirect();
  }

  constructor() {
    super();

    makeObservable<IEnrollmentCensusReviewPageStore>(this, {
      getStatistics: action.bound,
      onCensusSubmit: action.bound,
    });
  }
}
